import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";

export function UsePaymentManagment() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getPaymentManagment = (callback, bool) => {
    MyAxios.get(`Admin_PaymentsManagment`, {
      headers: {
        IsPage: bool,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UpdatePaymentManagment = (state, Image, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Image) {
      data.append("Image", Image);
    }
    MyAxios.post(`Admin_PaymentsManagment`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    getPaymentManagment,
    UpdatePaymentManagment,
  };
}
